import { RentalInfoForm } from "shared/app/RentalInfoForm";
import { useUnitFormContext } from "../UnitFormProvider";
import { UnitGeneralForm } from "../../UnitGeneralForm";
import { PlanForm } from "shared/app/PlanForm";
import { AmenitiesForm } from "shared/app/AmenitiesForm";
import { PhotosForm } from "shared/app/PhotosForm";
import { PropertyKind } from "shared/types";
import { Show } from "shared/components";
import { useAuthContext } from "providers/Auth";

interface CreateUnitFormProps {
  propertyKind?: PropertyKind | null;
}

export const CreateUnitForm = ({ propertyKind }: CreateUnitFormProps) => {
  const { handleSubmit, register, values, sessionKey, setPhotosUploading } =
    useUnitFormContext();
  const { type } = useAuthContext();

  return (
    <form onSubmit={handleSubmit} className="space-y-4 max-w-[822px]">
      <UnitGeneralForm register={register} propertyKind={propertyKind} />
      <RentalInfoForm register={register} showFees />
      <Show if={propertyKind || type.isPmsListingSyncEnabled}>
        <PlanForm register={register} />
        <AmenitiesForm
          isUnit
          register={register}
          selectedAmenities={values.amenities}
          level="unit"
        />
        <PhotosForm
          onChange={(formattedPhotos) =>
            register("media").onChange(formattedPhotos)
          }
          sessionKey={sessionKey}
          setPhotosUploading={setPhotosUploading}
        />
      </Show>
    </form>
  );
};
